module.exports = __webpack_public_path__ + "9b43c86aece6b6cb3aea4650440a779d.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-94.png
// module id = 154
// module chunks = 0